(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('User', ['$localStorage', 'HelperService', 'Weekday', UserFn]);


    /* main user model to interact with */
    function UserFn($localStorage, HelperService, Weekday) {
        var User = function () {

            // default attribues on create user

            // default language
            this.language = $localStorage.CurrentLanguage;
            this.fK_Language = $localStorage.CurrentLanguage.id;
            this.isConfirmed = true; //default -> only when "Patient/Representative/Client" creates an account on their own -> it must be confirmed
            this.licence = null;

            // file-path to user-image on server
            this.userImageTempFile = null;


            // default roles array
            this.userRoles = [];

            // detail object
            this.detail = {
                showOnIncomingCall: true
            };

            /* extend current object */
            this.extend = function (user) {
                var self = this;
                angular.extend(self, user);

                // ivr times
                if (self.ivrTimes) {
                    // set right weekday-enum
                    angular.forEach(Weekday, function (weekday) {
                        for (var i = 0; i < self.ivrTimes.length; i++) {
                            if (weekday.value === self.ivrTimes[i].weekday) {
                                self.ivrTimes[i].weekday = weekday;
                                break;
                            }
                        }
                    });
                } // if               

            }; // this

            /* do some cleaning and backend prepare */
            this.prepareForSave = function (selectedUserRoles) {
                // prepare for save
                this.fK_Language = this.language ? this.language.id : null;
                this.fK_MedicalDiscipline = this.discipline ? this.discipline.id : null;
                this.fK_Licence = this.licence ? this.licence.id : null;

                if (this.detail) {
                    // country                    
                    this.detail.fK_Country = this.detail && this.detail.country ? this.detail.country.id : null;
                    delete this.detail.country;
                    // start page
                    this.detail.startPage = this.detail.vmStartPage ? this.detail.vmStartPage.value : null;
                } // if

                // delete contact info objects -> only ids needed
                angular.forEach(this.contactInfos, function (item) {
                    delete item.userContactInfoType;
                });

                // ivr times
                if (this.ivrTimes) {
                    this.ivrTimes.forEach(function (item) {
                        item.weekday = item.weekday.value ? item.weekday.value : item.weekday;
                    });
                } //if

                // add selected roles to user
                var userRoles = []; // clear
                if (selectedUserRoles && selectedUserRoles !== null) {
                    angular.forEach(selectedUserRoles, function (userRole) {
                        var ur = angular.copy(userRole);
                        delete ur.role;
                        userRoles.push(ur);
                    });
                }// If
                this.userRoles = userRoles;

                delete this.groupPractice;
                delete this.language;
                delete this.discipline;
                delete this.licence;
                if (this.detail) { delete this.detail.vmStartPage; }
                delete this.rpassword;
                delete this.agreed;
            }; // prepareForSave


        };


        return User;
    }
})();